import { defineMessages } from "react-intl";

import { IntegrationFieldName } from "@app/util/fieldModel/IntegrationFieldModel";

export const infoMessages = defineMessages<string>({
  [IntegrationFieldName.ERRORED_RECORDS_INCOMING]: {
    id: "integrations.syncArchive.columns.erroredRecordsIncoming",
    defaultMessage:
      "Count of record errors in Map My Customers. Download the file to diagnose and make changes.",
    description: "Errored Records Incoming field info on Integration",
  },
  [IntegrationFieldName.ERRORED_RECORDS_OUTGOING]: {
    id: "integrations.syncArchive.columns.erroredRecordsOutgoing",
    defaultMessage:
      "Count of record errors in Map My Customers. Download the file to diagnose and make changes.",
    description: "Errored Records Outgoing field info on Integration",
  },
  [IntegrationFieldName.NEW_RECORDS_INCOMING]: {
    id: "integrations.syncArchive.columns.newRecordsIncoming",
    defaultMessage: "Count of records created in Map My Customers",
    description: "New Records Incoming field info on Integration",
  },
  [IntegrationFieldName.NEW_RECORDS_OUTGOING]: {
    id: "integrations.syncArchive.columns.newRecordOutgoing",
    defaultMessage: "Count of records created in your CRM",
    description: "New Records Outgoing field info on Integration",
  },
  [IntegrationFieldName.SKIPPED_RECORDS_INCOMING]: {
    id: "integrations.syncArchive.columns.skippedRecordsIncoming",
    defaultMessage: "Count of records in Map My Customers that were not updated.",
    description: "Skipped Records Incoming field info on Integration",
  },
  [IntegrationFieldName.SKIPPED_RECORDS_OUTGOING]: {
    id: "integrations.syncArchive.columns.skippedRecordsOutgoing",
    defaultMessage: "Count of records in your CRM that were not updated.",
    description: "Skipped Records Outgoing field info on Integration",
  },
  [IntegrationFieldName.UPDATED_RECORDS_INCOMING]: {
    id: "integrations.syncArchive.columns.updatedRecordsIncoming",
    defaultMessage: "Count of records modified in Map My Customers",
    description: "Updated Records Incoming field info on Integration",
  },
  [IntegrationFieldName.UPDATED_RECORDS_OUTGOING]: {
    id: "integrations.syncArchive.columns.updatedRecordsOutgoing",
    defaultMessage: "Count of records modified in your CRM",
    description: "Updated Records Outgoing field info on Integration",
  },
});
